import { useState, useEffect, useCallback } from "react";
import axios from "axios";

const useVideos = (baseURL = "http://localhost:2500") => {
    const [videos, setVideos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // Fetch all videos
    const fetchVideos = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const res = await axios.get(`${baseURL}/api/videos/all`);
            setVideos(res.data.files || []);
        } catch (err) {
            console.error("Failed to fetch videos:", err);
            setError(err);
        } finally {
            setLoading(false);
        }
    }, [baseURL]);

    // Upload new videos
    const uploadVideos = async (files) => {
        const form = new FormData();
        files.forEach(file => form.append("videos", file));
        try {
            await axios.post(`${baseURL}/api/video`, form, {
                headers: { "Content-Type": "multipart/form-data" }
            });
            await fetchVideos();
        } catch (err) {
            console.error("Upload failed:", err);
            setError(err);
        }
    };

    // Delete a video
    const deleteVideo = async (filename) => {
        try {
            await axios.post(`${baseURL}/api/video/delete`, { filename });
            await fetchVideos();
        } catch (err) {
            console.error("Delete failed:", err);
            setError(err);
        }
    };

    // Reorder videos
    const reorderVideos = async (filenames) => {
        try {
            await axios.post(`${baseURL}/api/videos/reorder`, { filenames });
            await fetchVideos();
        } catch (err) {
            console.error("Reorder failed:", err);
            setError(err);
        }
    };

    // Auto-fetch on mount
    useEffect(() => {
        fetchVideos();
    }, [fetchVideos]);

    return {
        videos,
        loading,
        error,
        fetchVideos,
        uploadVideos,
        deleteVideo,
        reorderVideos
    };
};

export default useVideos;
